import googleMaps from 'utils/googleMaps';
import { getCountryName } from 'utils/internationalization';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCityStateString = (address: Record<string, any>) =>
  [
    address.city,
    address.stateCode,
    address.country === 'US' ? null : getCountryName(address.country),
  ]
    .filter((part) => part)
    .join(', ');
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAddressString = (address: Record<string, any>) => {
  let addressString = [
    address.line1,
    address.line2,
    address.city,
    address.stateCode,
  ]
    .filter((part) => part)
    .join(', ');

  if (address.zipcode) {
    addressString += ` ${address.zipcode}`;
  }

  if (address.country !== 'US') {
    addressString += `, ${address.country}`;
  }

  return addressString;
};

const compareNoCase = (s1: string, s2: string) =>
  s1 && s2 ? s1.toLowerCase() === s2.toLowerCase() : s1 === s2;

export const lookupAddress = (
  {
    textQuery,
    addressData,
  }: {
    textQuery: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addressData: Record<string, any>;
  } // Convert google maps callback into a promise
) =>
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  new Promise<Record<string, any>>((resolve, reject) => {
    googleMaps()
      .then((maps) => {
        new maps.Geocoder().geocode(
          {
            address: textQuery,
            componentRestrictions: {
              country: addressData.country || [],
            },
          },
          (results) => {
            // prevent results that could have come back later from overriding this.
            const update = {};

            if (results && results.length > 0) {
              const result = results[0];

              if (['US', 'CA'].includes(addressData.country)) {
                const stateComponent = result.address_components.find((c) =>
                  c.types.includes('administrative_area_level_1')
                );

                if (
                  stateComponent &&
                  (compareNoCase(stateComponent.long_name, addressData.state) ||
                    compareNoCase(stateComponent.short_name, addressData.state))
                ) {
                  // Only update the address if there is a valid state / province
                  // @ts-expect-error ts-migrate(2339) FIXME: Property 'stateCode' does not exist on type '{}'.
                  update.stateCode = stateComponent.short_name;
                  // @ts-expect-error ts-migrate(2339) FIXME: Property 'latitude' does not exist on type '{}'.
                  update.latitude = result.geometry.location.lat();
                  // @ts-expect-error ts-migrate(2339) FIXME: Property 'longitude' does not exist on type '{}'.
                  update.longitude = result.geometry.location.lng();
                  // @ts-expect-error ts-migrate(2339) FIXME: Property 'latLongAddress' does not exist on type '... Remove this comment to see the full error message
                  update.latLongAddress = result.formatted_address;
                  // @ts-expect-error ts-migrate(2339) FIXME: Property 'full' does not exist on type '{}'.
                  update.full = result.formatted_address;
                }
              } else {
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'latitude' does not exist on type '{}'.
                update.latitude = result.geometry.location.lat();
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'longitude' does not exist on type '{}'.
                update.longitude = result.geometry.location.lng();
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'latLongAddress' does not exist on type '... Remove this comment to see the full error message
                update.latLongAddress = result.formatted_address;
                // @ts-expect-error ts-migrate(2339) FIXME: Property 'full' does not exist on type '{}'.
                update.full = result.formatted_address;
              }
            }

            resolve(update);
          }
        );
      })
      .catch((error) => {
        reject(error.message);
      });
  });
